// extracted by mini-css-extract-plugin
export default {"service_main":"S4_Services_service_main__D8u34","service_header_text":"S4_Services_service_header_text__hLx-w","service_Desc_text":"S4_Services_service_Desc_text__Ptvif"};